import { Store } from '../core/store';

export type ToastType = 'success' | 'info' | 'warning';

export interface ToastState {
  message: string;
  type: ToastType;
}

export const toastStore = new Store<ToastState | null>(null);

let timer: ReturnType<typeof setTimeout> | undefined;

/** Mock ile aynı davranış: 2.6 sn görünür, yenisi öncekini ezer. */
export function showToast(message: string, type: ToastType = 'success'): void {
  clearTimeout(timer);
  toastStore.set({ message, type });
  timer = setTimeout(() => toastStore.set(null), 2600);
}

export const TOAST_ICONS: Record<ToastType, string> = {
  success: 'ti ti-circle-check',
  info: 'ti ti-info-circle',
  warning: 'ti ti-alert-triangle',
};

export const TOAST_COLORS: Record<ToastType, string> = {
  success: 'var(--vx-success)',
  info: 'var(--vx-info)',
  warning: 'var(--vx-warning)',
};
